module.exports = __webpack_public_path__ + "img/grease_cup.prt.a5215686.jpg";